/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OralGatewayResponse { 
    status: string;
    happyapp_variant_id?: number;
    cake_status?: string;
    message?: string;
}

